var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Transform, Type } from "class-transformer";
import { JsonUtil } from "../../cutil/JsonUtil";
export class Suggestion {
    constructor() {
        this.suggested_input = "";
    }
}
export class QueryBuilderResponse {
}
export class CotResponse {
    constructor() {
        this.done = false;
        this.message = "";
        this.history = [];
    }
}
__decorate([
    Type(() => History),
    Transform(value => {
        return JsonUtil.toArrayFromType(History, value.value);
    }, { toClassOnly: true })
], CotResponse.prototype, "history", void 0);
export class History {
    constructor() {
        this.content = "";
    }
}
export var Role;
(function (Role) {
    Role["assistant"] = "assistant";
    Role["system"] = "system";
    Role["user"] = "user";
})(Role || (Role = {}));
export class Question {
    constructor() {
        this.question = "";
        this.answer = "";
    }
}
